var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGavel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1850_3028",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1850_3028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.80857 19.7501H14.8086C15.0214 19.7501 15.1996 19.8218 15.3432 19.9654C15.4868 20.109 15.5585 20.2872 15.5585 20.5C15.5585 20.7128 15.4868 20.891 15.3432 21.0346C15.1996 21.1782 15.0214 21.25 14.8086 21.25H4.80857C4.59575 21.25 4.41755 21.1782 4.27397 21.0346C4.13039 20.891 4.05859 20.7128 4.05859 20.5C4.05859 20.2872 4.13039 20.109 4.27397 19.9654C4.41755 19.8218 4.59575 19.7501 4.80857 19.7501ZM8.58169 14.8115L5.82399 12.0539C5.47913 11.709 5.30253 11.2862 5.29419 10.7856C5.28586 10.2849 5.45413 9.85898 5.79899 9.5077L6.31244 8.98465L11.6663 14.2885L11.1432 14.8115C10.7983 15.1564 10.3714 15.3288 9.86244 15.3288C9.35348 15.3288 8.92656 15.1564 8.58169 14.8115ZM15.7893 10.1654L10.4855 4.81157L11.0086 4.29813C11.3599 3.95326 11.7858 3.78499 12.2864 3.79332C12.7871 3.80166 13.2099 3.97826 13.5547 4.32313L16.3124 7.08082C16.6573 7.42569 16.8297 7.85261 16.8297 8.36157C16.8297 8.87054 16.6573 9.29747 16.3124 9.64235L15.7893 10.1654ZM20.074 19.6269L7.89707 7.45002L8.95089 6.3962L21.1278 18.5731C21.2663 18.7116 21.3371 18.8856 21.3403 19.0952C21.3435 19.3048 21.2727 19.4821 21.1278 19.6269C20.9829 19.7718 20.8073 19.8443 20.6009 19.8443C20.3945 19.8443 20.2189 19.7718 20.074 19.6269Z",
    fill: "#CED4DA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGavel);
export default __webpack_public_path__ + "static/media/gavel.a4d2127dcc1614a0d36e6d3db6e094e8.svg";
export { ForwardRef as ReactComponent };